// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3fxr8","content":"GlobalSearch_content__3CAx9"};